import React from 'react'
import Spinner from 'react-spinner'
import 'react-spinner/react-spinner.css'
import C from '../Const'
import PrintButton from '../PrintButton'
import R from '../ramda'
import { Col, Grid, Row } from '../react-bootstrap'
import ChartAssunzPerContr from './ChartAssunzPerContr'
import ChartAssunzPerTerr from './ChartAssunzPerTerr'
import ChartSaldoCumulato from './ChartSaldoCumulato'
import ChartSaldoPerCat from './ChartSaldoPerCat'
import DateTitolo from './DateTitolo'
import './Main.css'
import MapSaldo from './MapSaldo'
import RowTotali from './RowTotali'

function MainTerr(props) {
  const { filters, series, print, data, onDrillDownSett, hash } = props
  const has_terr_filters = R.pipe(
    R.keys,
    R.any((s) => /^terr_/.test(s)),
  )(filters)

  if (data == null || data.loading) {
    return <Spinner className="Main MainTerr loading" />
  } else if (data.error) {
    return (
      <div className="Main MainTerr error">
        {C.ERRORE}
        <pre>{data.error}</pre>
      </div>
    )
  }

  const { saldo_per_sett, map_saldo, year_bounds } = data

  return (
    <div className="Main MainTerr">
      <Grid>
        <Row className="Main-title clearfix">
          <Col sm={12}>
            <h1>
              Domanda di lavoro dipendente per territorio
              <DateTitolo from={filters.from} to={filters.to} yearBounds={year_bounds} />
            </h1>
          </Col>
        </Row>

        <RowTotali {...props} />

        <Row>
          <Col md={6} className="chart-container">
            <h2 className="bar-chart">Variazione occupazionale complessiva per settore</h2>
            <ChartSaldoPerCat
              series={series}
              chart_data={saldo_per_sett}
              onDrillDown={onDrillDownSett}
              print={print}
            />
          </Col>

          <Col md={6} className="chart-container">
            <h2 className="line-chart">Variazione occupazionale cumulata</h2>
            <ChartSaldoCumulato {...props} />
          </Col>
        </Row>

        <Row>
          <Col md={5}>
            <div className="chart-container">
              <h2 className="tree-chart">Numero di assunzioni</h2>
              <ChartAssunzPerTerr {...props} />
            </div>

            <div className="chart-container">
              <h2 className="radar-chart">Assunzioni per contratto</h2>
              <ChartAssunzPerContr {...props} />
            </div>
          </Col>

          <Col md={7} className="chart-container">
            <h2 className="geo-chart">Variazione occupazionale</h2>
            <MapSaldo
              map_data={map_saldo}
              with_shadow={has_terr_filters}
              series={series}
              print={print}
            />
          </Col>
        </Row>

        <Row>
          <Col md={12}>{print || <PrintButton app="terr" hash={hash} />}</Col>
        </Row>
      </Grid>
    </div>
  )
}

export default MainTerr



// WEBPACK FOOTER //
// ./src/main/MainTerr.js